import React, { createContext, useState, useContext } from 'react';
import { knowledgeService } from '../services/api';

export const SearchContext = createContext(null);

// Custom hook for using search context
export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchState, setSearchState] = useState({
    query: '',
    results: null,
    isSearching: false,
    error: null,
    currentPage: 1
  });

  // Execute search with optional filters
  const executeSearch = async (query, page = 1, filters = {}) => {
    try {
      setSearchState(prev => ({
        ...prev,
        isSearching: true,
        error: null
      }));

      const response = await knowledgeService.search(query, page, filters);
      
      setSearchState(prev => ({
        ...prev,
        query,
        results: response,
        currentPage: page,
        isSearching: false
      }));
    } catch (error) {
      setSearchState(prev => ({
        ...prev,
        error: error.message,
        isSearching: false
      }));
    }
  };

  // Clear search state
  const clearSearch = () => {
    setSearchState({
      query: '',
      results: null,
      isSearching: false,
      error: null,
      currentPage: 1
    });
  };

  const setPage = async (newPage) => {
    if (searchState.query) {
      return executeSearch(searchState.query, newPage);
    }
    return null;
  };

  return (
    <SearchContext.Provider value={{
      ...searchState,
      executeSearch, 
      clearSearch,   
      setPage
    }}>
      {children}
    </SearchContext.Provider>
  );
};
